import { useMediaQuery } from './useMediaQuery.js';

/**
 * Queries a set of common CSS media features, such as
 * orientation and user display preferences.
 */
function useMediaFeatures() {
  const [orientation, prefersReducedMotion, prefersColorSchemeDark, prefersColorSchemeLight, pointerCoarse, pointerFine] = useMediaQuery('(orientation: landscape)', '(prefers-reduced-motion)', '(prefers-color-scheme: dark)', '(prefers-color-scheme: light)', '(pointer: coarse)', '(pointer: fine)');
  return {
    prefersReducedMotion,
    prefersColorScheme: prefersColorSchemeDark ? 'dark' : prefersColorSchemeLight ? 'light' : 'none',
    orientation: orientation ? 'landscape' : 'portrait',
    pointer: pointerFine ? 'fine' : pointerCoarse ? 'coarse' : 'none'
  };
}

export { useMediaFeatures };
